// BidHistory.js
import React from "react";
import "./BidHistory.css";
import { useSelector,useDispatch } from "react-redux";
import { get_all_depends } from "../features/userSlice";
import { useT } from "../i18n";

const RequestHistory = () => {
    const { isUserLogedIn,Info,reuest_history } = useSelector((state) => state.users);

    const dispatch=useDispatch();
    const { t } = useT();
    React.useEffect(()=>{
      if(isUserLogedIn){
        
        let data = new FormData();
        data.append('phone_number',Info?.phone_number);
        dispatch(get_all_depends({request_type:'reuest_history',data:data}));
      }
     },[isUserLogedIn,Info?.phone_number,dispatch])


  return (
    <div className="bid-history-container" style={{marginBottom:'16%'}}>
      <h2 className="title">{t("User Withdrawal / deposit History")}</h2>
      <div className="table-wrapper">
        <table className="bid-history-table">
          <thead>
            <tr>
              <th>{t('Amount')}</th>
              <th>{t('Remark')}</th>
              <th>{t('Action')}</th>
              <th>{t('Status')}</th>
              <th>{t('Date')}</th>
            </tr>
          </thead>
          <tbody>
            {reuest_history.map((bid, index) => (
              <tr key={index}>
                <td>{bid.points}</td>
                <td>{bid.remark}</td>
                <td>{bid.action_type}</td>
                <td>{bid.status==="0"?<span style={{color:'#b9b925'}}>{t('Pending')}</span>:(bid.status==="-1")?<span style={{color:'#007bff'}}>{t('Failed')}</span>:<span style={{color:'green'}}>{t('Success')}</span>}</td>
                <td>{bid.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RequestHistory;
